export const MuiToggleButtonGroup = {
  styleOverrides: {
    root: {
      height: '30px',
      '& .MuiToggleButtonGroup-firstButton': {
        borderBottomLeftRadius: 100,
        borderTopLeftRadius: 100,
      },
      '& .MuiToggleButtonGroup-lastButton': {
        borderBottomRightRadius: 100,
        borderTopRightRadius: 100,
      },
    },
  },
};
